import React from 'react';
import { Box, Icon, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import {
    mapDispatchToProps,
    mapStateToProps,
    SearchEntryPointOverlayProps as Props,
    getTestIds,
    SearchEntryPointType,
} from 'component/common/SearchKeywordEntryPoint/SearchKeywordEntryPoint.selectors';
import { StringFormatter } from '@agoda/react-handyman';

const SearchKeywordEntryPointComponent: React.FC<Props> = (props: Props) => {
    const { searchType, geo, cms, inputText, onClickHandler, canShowInCitySearch } = props;
    const isShowKeywordSearch = inputText.length > 0;
    const { containerTestId, itemTestId } = getTestIds(searchType);
    const cityName = geo?.cityName || '';
    const keywordText = (
        <Typography display="inline-block" variant="body-s-strong">
            {inputText}
        </Typography>
    );
    const keywordSearchClickHandler = () => onClickHandler(searchType, inputText, geo);

    if (!isShowKeywordSearch || (searchType === SearchEntryPointType.InCity && !canShowInCitySearch)) {
        return null;
    }

    return (
        <Box data-element-name={containerTestId} data-testid={containerTestId} maxWidth="744px" mx="auto" px={props.isDesktop ? '4' : '12'} py="0" mb="0" width="100%">
            <Box
                as="button"
                interactive="product.primary"
                width="100%"
                p="12"
                display="flex"
                onClick={keywordSearchClickHandler}
                data-testid={itemTestId}
                data-element-name={itemTestId}
                borderRadius="8"
                my="8"
                mx="0"
            >
                {props.showPrefixIcon && <Icon id="fill.symbol.search" size="24" color="product.primary" me="12" />}
                <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
                    <div>
                        <Typography variant="body-s" mt="4">
                            {StringFormatter.formatToJsx(cms, keywordText, cityName)}
                        </Typography>
                    </div>
                    {props.showSuffixIcon && <Icon id="fill.arrow.thin-right" size="24" color="product.primary" />}
                </Box>
            </Box>
        </Box>
    );
};

SearchKeywordEntryPointComponent.displayName = 'SearchKeywordEntryPointComponent';

const SearchKeywordEntryPoint = connect(mapStateToProps, mapDispatchToProps)(SearchKeywordEntryPointComponent);

export default SearchKeywordEntryPoint;
